import React from 'react';
import { footerLinks } from '../data/content';
export function Footer() {
  return <footer className="w-full bg-navy-deep px-5 py-14" data-id="element-104" data-mp="3geze367ujv27">
      <div className="mx-auto w-full max-w-[1120px]" data-id="element-105" data-mp="3ggk6oqalp3xf">
        <div className="flex flex-col items-center gap-8 border-b border-white/10 pb-10 sm:flex-row sm:justify-between" data-id="element-106" data-mp="32oe0nx15wdbp">
          <p className="font-display text-2xl font-bold uppercase tracking-[0.12em] text-white" data-id="element-107" data-mp="36q92d2n08sq0">
            <span className="border-b-2 border-red pb-1" data-id="element-108" data-mp="3ugbs3c3g5mlg">Håndboldklar</span>
          </p>

          <ul className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-sm text-white/60" data-id="element-109" data-mp="37o5kstgztcb">
            {footerLinks.map((link, index) => <React.Fragment key={link} data-id="element-110" data-mp="3qdf5796vj4bp" data-mpi={index}>
                {index > 0 && <li aria-hidden="true" className="text-white/25" data-id="element-111" data-mp="3qfjighqnxfon">
                    ·
                  </li>}
                <li data-id="element-112" data-mp="2ey0907mhoghn">
                  <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-113" data-mp="2eyjq5m4bf0um">
                    {link}
                  </a>
                </li>
              </React.Fragment>)}
          </ul>
        </div>

        <p className="mx-auto mt-10 max-w-2xl text-center text-xs leading-relaxed text-white/55" data-id="element-114" data-mp="3v7zwheoz6um9">
          Håndboldklar er et uafhængigt produkt og er ikke tilknyttet, godkendt af eller
          sponsoreret af DanskHåndbold (DHF).
        </p>
      </div>
    </footer>;
}